import { render, staticRenderFns } from "./StudentLocalTraining.vue?vue&type=template&id=687ca63a&"
import script from "./StudentLocalTraining.js?vue&type=script&lang=js&"
export * from "./StudentLocalTraining.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports